import { defineMessages } from 'react-intl-next';

const messages = defineMessages({
	deletePageModalTitle: {
		id: 'hub.home.delete.page.modal.title',
		defaultMessage: 'Delete ‘{value}’?',
		description: 'Title for the delete page confirmation modal dialog',
	},
	deletePageModalModalDesc: {
		id: 'hub.home.delete.page.modal.description',
		defaultMessage:
			'‘{value}’ and any customizations you applied to it will be permanently deleted. This cannot be undone.',
		description: 'Description text in the delete page confirmation modal dialog',
	},
	deletePageModalModalCancelButton: {
		id: 'hub.home.delete.page.modal.cancel.button',
		defaultMessage: 'Cancel',
		description: 'Cancel button text in delete page confirmation modal dialog',
	},
	deletePageModalModalConfirmButton: {
		id: 'hub.home.delete.page.modal.confirm.button',
		defaultMessage: 'Delete',
		description: 'Confirm delete button text in delete page confirmation modal dialog',
	},
	deletePageModalModalSuccessTitle: {
		id: 'hub.home.delete.page.modal.success.title',
		defaultMessage: '‘{value}’ has been deleted',
		description: 'Success flag title after deleting a page successfully',
	},
	deletePageModalModalErrorTitle: {
		id: 'hub.home.delete.page.modal.error.title',
		defaultMessage: 'Failed to delete page',
		description: 'Error flag title when page deletion fails',
	},
	deletePageModalModalErrorDesc: {
		id: 'hub.home.delete.page.modal.error.description',
		defaultMessage: 'Something went wrong while deleting ‘{value}’. Please try again.',
		description: 'Error flag description when page deletion fails',
	},
});

export default messages;
